(function () {
	var toggles = document.querySelectorAll('.js-mobile-nav-toggle');
	var drawer = document.getElementById('mobileNavDrawer');
	var overlay = document.getElementById('mobileNavOverlay');
	var closeBtn = document.querySelector('.mobileNavClose');

	if (!toggles.length || !drawer || !overlay) return;

	function setTogglesExpanded(expanded) {
		toggles.forEach(function (btn) {
			btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
		});
	}

	function openDrawer() {
		if (drawer.classList.contains('is-open')) return;
		drawer.removeAttribute('inert');
		drawer.classList.add('is-open');
		overlay.classList.add('is-open');
		document.body.classList.add('mobileNavOpen');
		setTogglesExpanded(true);
		drawer.setAttribute('aria-hidden', 'false');
		overlay.setAttribute('aria-hidden', 'false');
		if (closeBtn) closeBtn.focus();
	}

	function closeDrawer() {
		if (!drawer.classList.contains('is-open')) return;
		drawer.classList.remove('is-open');
		drawer.setAttribute('inert', '');
		overlay.classList.remove('is-open');
		document.body.classList.remove('mobileNavOpen');
		setTogglesExpanded(false);
		drawer.setAttribute('aria-hidden', 'true');
		overlay.setAttribute('aria-hidden', 'true');
		var firstToggle = toggles[0];
		if (firstToggle && typeof firstToggle.focus === 'function')
			firstToggle.focus();
	}

	function onToggleClick() {
		if (drawer.classList.contains('is-open')) {
			closeDrawer();
		} else {
			openDrawer();
		}
	}

	toggles.forEach(function (toggle) {
		toggle.addEventListener('click', onToggleClick);
	});

	if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
	overlay.addEventListener('click', closeDrawer);

	document.addEventListener('keydown', function (e) {
		if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
			closeDrawer();
		}
	});

	var drawerNav = document.querySelector('.mainNav--drawer');
	if (drawerNav) {
		drawerNav.addEventListener('click', function (e) {
			if (e.target.closest('a')) closeDrawer();
		});
	}
})();
